export default "__VITE_ASSET__CG9iJ8yh__"